import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from '../Pages/Home';
import Success from '../Pages/Success';
import Fail from '../Pages/Fail';
import Subscription from '../Pages/Subscription';
const Router = () => {
	return (
		<div>
			<BrowserRouter>
				<Routes>
					<Route index element={<Home />} />
					<Route path="/r/:code" element={<Home />} />
					<Route path="/subscription" element={<Subscription />} />
					<Route path="/s/:code" element={<Subscription />} />
					<Route path="/success" element={<Success />} />
					<Route path="/failed" element={<Fail />} />
				</Routes>
			</BrowserRouter>
		</div>
	)
}

export default Router;